import Button from '@cartwhl/ui/input/Button';

import { useAssetLibraryEmbedConfig } from '../assetLibraryEmbedContext';
import { getMediaPickerConfirmLabel } from '../assetLibraryMediaSelection';
import { useAssetLibraryMediaSelection } from '../hooks/useAssetLibraryMediaSelection';

export default function AssetLibraryMediaPickerFooter() {
  const embedConfig = useAssetLibraryEmbedConfig();
  const mediaSelection = useAssetLibraryMediaSelection();
  const staged = embedConfig?.mediaSelection;

  if (!staged || !mediaSelection?.isStagedSelection) {
    return null;
  }

  const confirmLabel = getMediaPickerConfirmLabel({
    mediaKind: staged.mediaKind,
    count: mediaSelection.selectedCount,
  });

  return (
    <div className="border-primary flex shrink-0 items-center justify-between gap-3 border-t px-6 py-4">
      <Button
        variant="secondary"
        size="sm"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          mediaSelection.cancelSelection();
        }}
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        size="sm"
        disabled={mediaSelection.selectedCount === 0}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          mediaSelection.confirmSelection();
        }}
      >
        {confirmLabel}
      </Button>
    </div>
  );
}
